import { useCallback, useEffect, useRef, useState } from "react";
import { getMyProfile } from "../../../service/usersService";
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { MINIO } from "../../../data/data";
import { checkImageExists } from "../../../utls/img";
import { setUser } from "../../../redux/utlsSlice";
import { initialUsers } from "../../../type/users";
import { toPng } from "html-to-image";

const IdCard = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [users, setUsers] = useState(initialUsers);

  const [imagePreview, setImagePreview] = useState("");
  const [imageExists, setImageExists] = useState(false);

  const getMyDataProfile = async () => {
    const response = await getMyProfile();
    if (!response?.error) {
      setUsers(response?.data);
      loadImage(response?.data.thumbnail);
    }
  };

  useEffect(() => {
    getMyDataProfile();
  }, []);

  const loadImage = async (thumbnail: string) => {
    const imageUrl = `${MINIO}/${thumbnail}`;
    const exists = await checkImageExists(imageUrl);
    setImageExists(exists);
    setImagePreview(exists ? imageUrl : "/assets/imgs/no-user-image-icon.jpg");
  };

  const onButtonClick = useCallback(() => {
    if (ref.current === null) {
      return;
    }

    toPng(ref.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = new Date().toISOString() + ".png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }, [ref]);

  return (
    <div className="bg-white min-h-screen w-[480px] m-auto  overflow-auto p-3 text-center">
      <div ref={ref} className="w-[440px] text-center">
        <div className="backround-card ">
          <div className="img-member">
            <img src={imagePreview} alt="" />
          </div>
          <div className="absolute right-3 bottom-[40px] text-white text-right">
            <span className="block text-[15px] font-bold">
              {users.fullName}
            </span>
            <span className="block text-[12px]">
              {users.memberType.name} - {users.provinsi.provinsiName}
            </span>
            <span className="block text-[12px]">{users.code}</span>
          </div>
        </div>
      </div>
      <button
        onClick={() => {
          onButtonClick();
        }}
        className="btn btn-warning my-4 "
      >
        Download
      </button>
    </div>
  );
};

export default IdCard;
